import { GUIA_LABELS } from '@utils/guiaLabels.js'
import { EmptyPanel } from '@components/primitives/EmptyPanel.js'
import { NavIcon } from '@components/layout/NavIcons.js'
import { getTopicoTipo, TIPO_LABEL, TIPO_CLASS } from '@utils/topicoTipo.js'

interface Props {
  topicoId: string
  topicoSlug: string
  moduloId: string
  temFerramenta: boolean
  checklistItems: { id: string }[]
  nested?: boolean
}

export function PassoFazerSection({
  topicoId,
  topicoSlug,
  moduloId,
  temFerramenta,
  checklistItems,
  nested,
}: Props) {
  const tipo = getTopicoTipo(moduloId, topicoSlug, topicoId)
  const temObra = temFerramenta || checklistItems.length > 0

  if (temObra) {
    return (
      <div className={nested ? 'cf3-block cf3-block--nested' : 'cf3-block'}>
        <EmptyPanel
          className='cf3-empty-panel--compact'
          icon={<NavIcon icon='etapa' size={22} />}
          title='Registre na sua obra'
          description={
            <>
              {temFerramenta && checklistItems.length > 0
                ? 'Recurso, confirmações e anotações estão na aba '
                : temFerramenta
                  ? `O recurso ${GUIA_LABELS.destaEtapa} está na aba `
                  : 'Confirmações e anotações estão na aba '}
              <strong>Registrar</strong>.
            </>
          }
        >
          <span className={TIPO_CLASS[tipo]}>{TIPO_LABEL[tipo]}</span>
        </EmptyPanel>
      </div>
    )
  }

  return (
    <div className={nested ? 'cf3-block cf3-block--nested' : 'cf3-block'}>
      <EmptyPanel
        icon={<NavIcon icon='checklist' size={22} />}
        title='Leia e decida'
        description='Use as dicas acima, anote o que for importante na aba Registrar e marque a etapa como concluída quando decidir.'
      >
        <span className={TIPO_CLASS[tipo]}>{TIPO_LABEL[tipo]}</span>
      </EmptyPanel>
    </div>
  )
}
